import { FormEvent, useState } from 'react'

import { Card, CardContent, CardHeader, CardTitle, Input, Label, PosButton, Spinner } from '@/components/ui'
import { useSession } from '@/contexts/SessionContext'

/** Password sign-in: first setup of a device (§15.10 step 2), or a cashier without a PIN on a set-up one. */
export const LoginPage = ({ onBack }: { onBack?: () => void }) => {
  const { login } = useSession()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = new FormData(e.currentTarget)
    setBusy(true)
    setError(null)
    try {
      await login(String(form.get('email')).trim(), String(form.get('password')))
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex h-dvh items-center justify-center bg-frame p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Sign in to the POS</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" name="email" type="email" autoComplete="username" required autoFocus />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" name="password" type="password" autoComplete="current-password" required />
            </div>
            {error && <p className="text-sm text-destructive">{error}</p>}
            <PosButton type="submit" size="touch" className="w-full" disabled={busy}>
              {busy ? <Spinner /> : 'Sign in'}
            </PosButton>
            {onBack && (
              <PosButton type="button" variant="ghost" className="w-full" onClick={onBack}>
                Back to PIN
              </PosButton>
            )}
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
